import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';

interface ModelUsageData {
    model: string;
    count: number;
    [key: string]: any;
}

interface ModelUsageChartProps {
    data: ModelUsageData[];
}

const ModelUsageChart: React.FC<ModelUsageChartProps> = ({ data }) => {

    const COLORS = [
        "hsl(var(--primary))",
        "hsl(var(--secondary))",
        "hsl(var(--accent))",
        "hsl(var(--destructive))",
        "hsl(var(--muted))",
        "hsl(var(--input))",
        "hsl(var(--ring))",
    ];

    const formatTooltipValue = (value: number | string | Array<number | string> | undefined, name: string | undefined) => {
        if (value === undefined) return ['', name ?? ''];
        const numValue = Number(value);
        if (isNaN(numValue)) return [String(value), name ?? ''];

        const total = data.reduce((sum, item) => sum + item.count, 0);
        const percentage = total > 0 ? ((numValue / total) * 100).toFixed(1) : '0';
        return [`${numValue} calls (${percentage}%)`, name ?? ''];
    };

    return (
        <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                    <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        label={({ name, percent }: { name?: string | number; percent?: number }) => 
                            `${name ?? ''} (${((percent || 0) * 100).toFixed(0)}%)`
                        }
                        outerRadius={80}
                        fill="hsl(var(--primary))"
                        dataKey="count"
                        nameKey="model"
                    >
                        {data.map((_, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                    </Pie>
                    <Tooltip
                        contentStyle={{
                            backgroundColor: "hsl(var(--background))",
                            border: "1px solid hsl(var(--border))",
                            borderRadius: '8px',
                        }}
                        labelStyle={{ color: "hsl(var(--foreground))" }}
                        itemStyle={{ color: "hsl(var(--foreground))" }}
                        formatter={formatTooltipValue}
                    />
                    <Legend
                        wrapperStyle={{ color: "hsl(var(--muted-foreground))" }}
                    />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
};

export default ModelUsageChart;
